(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-row/assets/javascripts/animations/core.js') >= 0) return;  svs.modules.push('/components/tur/ball-row/assets/javascripts/animations/core.js');

'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.row = svs.tur.ball.row || {};
svs.tur.ball.row.animations = svs.tur.ball.row.animations || {};
class Core {
  fadeIn(row) {
    const tl = gsap.timeline();
    tl.fromTo(row.$el, {
      opacity: 0
    }, {
      duration: 0.5,
      opacity: 1
    });
    if (row.balls) {
      row.balls.forEach(ball => {
        const ballTl = ball.fadeIn();
        tl.add(ballTl, '<.2');
      });
    }
    tl.timeScale(1.2);
    return tl;
  }
  fadeOut(row) {
    return this.fadeIn(row).reverse(0);
  }
  show(row) {
    const balls = row.balls.map(ball => ball.$el);
    return gsap.set([row.$el, balls], {
      opacity: 1
    });
  }
  rollIn(row) {
    const tl = gsap.timeline();
    tl.fromTo(row.$el, {
      opacity: 0,
      scale: 0.5
    }, {
      duration: 0.3,
      opacity: 1,
      scale: 1,
      ease: 'back.out'
    });
    row.balls.forEach((ball, i) => {
      const ballTl = ball.rollIn();
      tl.add(ballTl, i > 0 && "-=".concat(ballTl.duration() * 0.97));
    });
    return tl;
  }
  wave(row) {
    const tl = gsap.timeline();
    row.balls.forEach((ball, i) => {
      const ballTl = ball.wave();
      tl.add(ballTl, i > 0 && "-=".concat(ballTl.duration() * 0.9));
    });
    return tl;
  }
  clear(row) {
    const tl = gsap.timeline();
    const reversedBalls = row.balls.reverse();
    reversedBalls.forEach((ball, i) => {
      const ballTl = ball.clear();
      tl.add(ballTl, i > 0 && "-=".concat(ballTl.duration() * 0.9));
    });
    return tl;
  }
  slideIn(row) {
    const tl = gsap.timeline();
    tl.fromTo(row.$el, {
      opacity: 0,
      x: _.random(-30, 30)
    }, {
      opacity: 1,
      x: 0,
      rotation: 0,
      ease: 'back.out'
    });
    if (row.balls) {
      row.balls.forEach(ball => {
        ball.show();
      });
    }
    return tl;
  }
}
svs.tur.ball.row.animations.Core = new Core();

 })(window);